import React from "react";
import { Text, View } from "@react-pdf/renderer";
import { styles } from "../styles";

export const ProductLineItemHeader = () => (
  <View style={[styles.row, styles.productLineItemHeader]} fixed>
    <Text style={styles.column.position}>Pos</Text>
    <Text style={styles.column.collection}>Kollektion</Text>
    <Text style={styles.column.model}>Modell</Text>
    <Text style={styles.column.color}>Farbcode</Text>
    <Text style={styles.column.deliveryDate}>Lieferdatum</Text>
    <Text style={styles.column.amount}>Menge</Text>
  </View>
);
